import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, TextField } from "@mui/material";
import useStyles from './Reports.styles';
import { actions } from './Reports.redux';
import DashboardCard from "components/DashboardCard";
import { Search } from "@mui/icons-material";



const ContentBlockSearch = () => {
    const classes       = useStyles(),
          dispatch      = useDispatch(),
          searchTerms   = useSelector(state => state.reports.contentBlockSearch),
          loading       = useSelector(state => state.reports.loading),
          setSearchTerm = (key, value) => dispatch(actions.setSearchTerm('contentBlockSearch', key, value));


    const handleChange = e => setSearchTerm(e.target.name, e.target.value);

    const handleSubmit = e => {
        e.preventDefault();
        dispatch(actions.setSubState('contentBlocks', { pageNumber: 0 }));
        dispatch(actions.loadContentBlocks());
    };


    const handleReset = () => {
        if(!searchTerms.string_name) {
            return false;
        }

        dispatch(actions.setSubState('contentBlocks', { pageNumber: 0 }));
        setSearchTerm('string_name', '');
        dispatch(actions.loadContentBlocks());
    };


    return (
        <div className={classes.searchContainer}>
            <DashboardCard
                color={'amber'}
                icon={<Search />}
                topContent={"Content Block Search"}
                topLabel="Enter search criteria below"
                size="xl"
            >
                <form method="post" onSubmit={handleSubmit}>
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <TextField
                                label="Content Block Name"
                                variant="outlined"
                                fullWidth
                                value={searchTerms.string_name}
                                name="string_name"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.searchButtons}
                                disabled={loading}
                                type="submit"
                                onClick={handleSubmit}
                            >
                                Search
                            </Button>

                            <Button
                                variant="outlined"
                                color="primary"
                                size="large"
                                className={classes.searchButtons}
                                disabled={loading}
                                onClick={handleReset}
                            >
                                Reset
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </DashboardCard>
        </div>

    );
};


export default ContentBlockSearch;